<template>
  <div class="video-wrapper">
    <youtube
      ref="youtube"
      v-bind:video-id="videoId"
      v-bind:player-vars="{rel: 0}"
      v-bind:resize="true"
      v-bind:fit-parent="true"
    ></youtube>
  </div>
</template>

<script>
export default {
  name: 'VideoCentered',
  props: ['video-id'],
  data: function () {
    return {}
  },
  computed: {
    player: function () {
      return this.$refs.youtube.player
    }
  }
}
</script>

<style scoped lang="scss">
  .video-wrapper {
    @include centered-block-width($desktop: 70%, $mobile: 100%);
    max-width: 100%;
    overflow: hidden;
    @media only print { display: none; }
  }
</style>



// WEBPACK FOOTER //
// src/components/the-content/utils/VideoCentered.vue